import {
  useMutation,
  useQueryClient,
  UseMutationResult,
} from '@tanstack/react-query';

import { updateTeamDetails, UpdateTeamInput } from '../queries/updateTeamData';

export function useUpdateTeam(): UseMutationResult<
  void,
  Error,
  UpdateTeamInput
> {
  const queryClient = useQueryClient();

  return useMutation<void, Error, UpdateTeamInput>({
    mutationFn: (input: UpdateTeamInput) => updateTeamDetails(input),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['teams'] });
      await queryClient.invalidateQueries({ queryKey: ['userTeam'] });
      await queryClient.invalidateQueries({ queryKey: ['teamMembers'] });
      await queryClient.invalidateQueries({ queryKey: ['teamDetails'] });
      await queryClient.invalidateQueries({ queryKey: ['userTeam'] });
    },
  });
}
